import React from 'react';
import './Footer2.css';

const FOOTER_TAGLINE_BY_LANGUAGE = {
  de: 'Ihr zuverlässiger Partner für Gruppenreisen von Alpen bis nach Adria',
  en: 'Your trusted partner for unforgettable journeys from the Alps to the Adriatic',
  it: "Il vostro partner affidabile per viaggi di gruppo dalle Alpi fino all'Adriatico"
};

const Footer2 = ({ language = 'en' }) => {
  const year = new Date().getFullYear();
  const tagline = FOOTER_TAGLINE_BY_LANGUAGE[language] || FOOTER_TAGLINE_BY_LANGUAGE.en;

  return (
    <footer className="footer2">
      <div className="footer2-container">
        <div className="footer2-content">
          <div className="footer2-brand">
            <h3>ALLEGROTOURS</h3>
            <p>{tagline}</p>
          </div>
          
          <div className="footer2-info">
            <p>&copy; {year} AllegroTours. All rights reserved.</p>
            <p>Designed with care for tour operators and travel enthusiasts</p>
            <p>
              Tel: <a href="tel:+38645747099">+386 4 57 47 099</a> ·{' '}
              Fax: <a href="tel:+38645747098">+386 4 57 47 098</a> ·{' '}
              Mobile: <a href="tel:+38631336704">+386 31 336 704</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
